import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../../config";
import "./CreatePage.css";

const DRAFTS_KEY = "dmyor_vision_drafts";
const VISIT_KEY = "dmyor_create_visit";

const CreatePage = () => {
  const navigate = useNavigate();
  const [draftCount, setDraftCount] = useState(0);

  useEffect(() => {
    try {
      const drafts = JSON.parse(localStorage.getItem(DRAFTS_KEY)) || [];
      setDraftCount(drafts.length);
    } catch {
      setDraftCount(0);
    }

    // Fire once per session
    if (!sessionStorage.getItem(VISIT_KEY)) {
      sessionStorage.setItem(VISIT_KEY, "1");
      axios.post(`${config.apiUrl}/api/v1/me/create-page-visit`, {}, { withCredentials: true }).catch(() => {});
    }
  }, []);

  return (
    <div className="create-page">
      <div className="create-cards">

        <div
          className="create-card"
          onClick={() => navigate("/dashboard/planning/new")}
        >
          <h2>Create a Vision</h2>
          <p>
            Create your version of where you will be over the next 1 to 5 years.
            Write your future and make it a reality.
          </p>
          <div className="arrow">→</div>
        </div>

        <div
          className="create-card"
          onClick={() => navigate("/dashboard/side-quest/new")}
        >
          <h2>Side Quest</h2>
          <p>
            Quests you take on just because you want to! A record of you making what
            you want a reality.
          </p>
          <div className="arrow">→</div>
        </div>

        {draftCount > 0 && (
          <div
            className="create-card create-card-drafts"
            onClick={() => navigate("/dashboard/drafts")}
          >
            <div className="create-card-drafts-badge">{draftCount}</div>
            <h2>Drafts</h2>
            <p>
              You have {draftCount} saved vision draft{draftCount !== 1 ? "s" : ""}.
              Pick up where you left off.
            </p>
            <div className="arrow">→</div>
          </div>
        )}

      </div>
    </div>
  );
};

export default CreatePage;
